import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditPaginationRuleModal from '@modals/CreateOrEditPaginationRuleModal'

import PageContent from './components/PageContent'

const callbacks = (component: keyof typeof componentCallbacks, setState: Function) => {
  const componentCallbacks = {
    CreateOrEditPaginationRuleModal: {
      closeModal: () => setState({ showCreateOrEditPaginationRuleModal: false }),
      createPaginationRule: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateOrEditPaginationRuleModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditPaginationRuleModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      deletePaginationRule: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      showCreateOrEditPaginationRuleModal: (payload: HandleCallbackActionParams) => {
        setModalData('CreateOrEditPaginationRuleModal', payload)
        setState({ showCreateOrEditPaginationRuleModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateOrEditPaginationRuleModal
          // @ts-expect-error TS2322
          callbacks={callbacks('CreateOrEditPaginationRuleModal', setState)}
          showModal={showCreateOrEditPaginationRuleModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
